import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { useMergeRefs } from 'use-callback-ref';
import '../../../../primitives/Box/Box.es.js';
import '../../../../primitives/Center/styled.es.js';
import '../../../../primitives/Group/Group.es.js';
import '../../../../primitives/Grid/Grid.es.js';
import '../../../../primitives/Level/Level.es.js';
import '../../../../primitives/Shelf/Shelf.es.js';
import { Portal } from '../../../../primitives/Portal/Portal.es.js';
import '../../../../primitives/Hidden/Hidden.es.js';
import '../../../../primitives/Media/Media.es.js';
import '../../../../primitives/Dialog/Dialog.es.js';
import '../../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../../primitives/Popper/Popper.es.js';
import '../../../../primitives/DragHandle/DragHandle.es.js';
import '../../../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import { Fade } from '../../../Fade/Fade.es.js';
import { matchWidth } from '../../../../primitives/Popper/modifiers.es.js';
import { useAutocompleteDropdown } from './AutocompleteContext.es.js';
import { Dropdown as Dropdown$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var popperOptions = {
  placement: "bottom-start",
  modifiers: [matchWidth, {
    name: "flip",
    options: {
      padding: 8
    }
  }]
};
var Dropdown = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      anchorRef = _a.anchorRef,
      rest = __objRest(_a, ["children", "anchorRef"]);

  var _useState = useState(null),
      popperElement = _useState[0],
      setPopperElement = _useState[1];

  var _useAutocompleteDropd = useAutocompleteDropdown(),
      isOpen = _useAutocompleteDropd.isOpen;

  var _usePopper = usePopper(anchorRef, popperElement, popperOptions),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  var dropdownRef = useMergeRefs([ref, setPopperElement]);
  useEffect(function () {
    if (!isOpen) return;
    update == null ? void 0 : update();
  }, [isOpen, update]);
  return (
    /* @__PURE__ */
    React.createElement(Portal, {
      zIndex: 1001
    },
    /* @__PURE__ */
    React.createElement(Fade, {
      in: isOpen,
      timeout: isOpen ? 100 : 0
    },
    /* @__PURE__ */
    React.createElement(Dropdown$1, __spreadValues(__spreadValues({
      ref: dropdownRef,
      style: __spreadProps(__spreadValues({}, styles.popper), {
        maxHeight: props.maxHeight
      })
    }, attributes.popper), rest), children)))
  );
});
export { Dropdown };